import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import WebFont from 'webfontloader';
import thunk from 'redux-thunk';

import App from './App';
import './assets/scss/main.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import authReducer from './store/reducers/auth';
import './components/UI/DynamicIcon/DynamicIcon';
import { ConfigProvider } from './shared/config';

// Redux browser extension setup for development env
const composeEnhancers =
    process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

const rootReducer = combineReducers({
    auth: authReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

// Todo: Better place for WebFont Loader?
if (process.env.REACT_APP_FONT_URL) {
    WebFont.load({
        custom: { families: [process.env.REACT_APP_FONT_FAMILIES], urls: [process.env.REACT_APP_FONT_URL] },
    });
}

if ('OTPCredential' in window) {
    const abortController = new AbortController();
    navigator.credentials
        .get({ otp: { transport: ['sms'] }, signal: abortController.signal })
        .then((credential) => {
            if (credential?.code) {
                localStorage.setItem('webOtpCode', JSON.stringify(credential.code));
            }
        })
        .catch((err) => {
            console.log('OTP credential resolving failed with:', err);
        });
}

const app = (
    <React.StrictMode>
        <Provider store={store}>
            <ConfigProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ConfigProvider>
        </Provider>
    </React.StrictMode>
);

createRoot(document.getElementById('root')).render(app);
serviceWorkerRegistration.register();
